
import axios from '@/libs/api.request'

export const getForm = (params) => { // 获取表单
    return axios.request({
        url: `/form/${params.id}`,
        method: 'get',
    })
}

// 获取填写过的表单数据(进行默认字段填充)
export const getOldFormdata = (params) => {
    return axios.request({
        url: '/form_user/last',
        method: 'post',
        data: params
    })
}

export const createForm = (params) => { // 聚合表单提交
    return axios.request({
        url: 'form_user/create',
        method: 'post',
        data: params,
        
    })
}